import Roles from "@/utils/roles"
import { isInRoles } from "@/utils/authorize.directive"

export default [
    {
        path: "/clipping-prospect",
        name: "clipping-prospect",
        component: () => import("@/views/area-mention/clipping-prospect/index.vue"),
        meta: {
          title: 'Clipping para prospect',
          authRequired: true,
          roles: [Roles.CommercialProspectClipping]
        },
        // A checagem genérica de meta.roles segue comentada no router/index.js.
        beforeEnter: (to, from, next) => {
          if (!isInRoles(Roles.CommercialProspectClipping)) {
            next({ name: 'home' })
            return
          }
          next()
        },
    },
];
